import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-27244ac9")

_pushScopeId("data-v-27244ac9")
const _hoisted_1 = {
  "data-testid": "booking-v4-jenis-pengiriman-vippack-discount-badge",
  class: "flex items-center gap-1 rounded-md px-2 py-1 bg-yellow-lp-400"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "flex items-center gap-custom" }, [
  /*#__PURE__*/_createVNode("div", { class: "dot rounded-full bg-gray-lp-600" }),
  /*#__PURE__*/_createVNode("div", { class: "dot rounded-full bg-gray-lp-600" }),
  /*#__PURE__*/_createTextVNode(" % ")
], -1)
const _hoisted_3 = { class: "flex items-center gap-custom" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.shouldMask)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          _createVNode("span", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.currencyPrefix) + " ", 1),
            (_openBlock(), _createBlock(_Fragment, null, _renderList(6, (n) => {
              return _createVNode("div", {
                key: n,
                class: "dot rounded-full bg-gray-lp-600"
              })
            }), 64))
          ])
        ], 64))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _createVNode("b", null, _toDisplayString(_ctx.$t("bookingV4.vippack.discountBadge", { discount: _ctx.commissionRate })), 1),
          _createVNode("span", null, _toDisplayString(_ctx.formattedAmount), 1)
        ], 64))
  ]))
})